import React from 'react';
import './SignatureViewer.css';

const SignatureViewer = ({ isOpen, onClose, signatureData, itemData }) => {
  if (!isOpen || !signatureData) return null;

  const { operator, receiver, timestamp, items } = signatureData;
  
  // Se há múltiplas peças na movimentação, mostrar todas
  const itemsToShow = items && items.length > 0 ? items : [itemData];

  const downloadSignature = () => {
    // Criar um novo documento HTML para impressão/download
    const printWindow = window.open('', '_blank');
    
    const htmlContent = `
      <!DOCTYPE html>
      <html lang="pt-BR">
      <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <title>Comprovante de Entrega - ${itemData?.cod_sis || 'N/A'}</title>
        <style>
          body {
            font-family: 'Segoe UI', Arial, sans-serif;
            margin: 0;
            padding: 15px;
            color: #333;
            line-height: 1.4;
            background: white;
          }
          
          .header {
            text-align: center;
            border-bottom: 3px solid #3b82f6;
            padding-bottom: 15px;
            margin-bottom: 20px;
          }
          
          .header h1 {
            color: #1e293b;
            margin: 0;
            font-size: 20px;
            font-weight: 700;
          }
          
          .header h2 {
            color: #64748b;
            margin: 8px 0 0 0;
            font-size: 14px;
            font-weight: 600;
          }
          
          .timestamp {
            font-size: 12px;
            color: #64748b;
            margin-top: 5px;
            font-weight: 500;
          }
          
          .items-section h3 {
            font-size: 14px;
            margin: 15px 0 10px 0;
            color: #1e293b;
            font-weight: 600;
          }
          
          .items-table {
            width: 100%;
            border-collapse: collapse;
            margin: 10px 0;
            font-size: 10px;
            box-shadow: 0 2px 8px rgba(0,0,0,0.1);
          }
          
          .items-table th, .items-table td {
            border: 1px solid #e2e8f0;
            padding: 6px 4px;
            text-align: left;
            vertical-align: top;
          }
          
          .items-table th {
            background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
            font-weight: 700;
            color: #475569;
            font-size: 9px;
            text-transform: uppercase;
            letter-spacing: 0.5px;
          }
          
          .items-table tbody tr:nth-child(even) {
            background-color: #f8fafc;
          }
          
          .items-table tbody tr:hover {
            background-color: #e2e8f0;
          }
          .signature-section {
            margin-top: 25px;
            display: flex;
            justify-content: space-between;
            gap: 30px;
          }
          
          .signature-field {
            flex: 1;
            text-align: center;
          }
          
          .signature-field h3 {
            margin-bottom: 8px;
            font-size: 12px;
            color: #1e293b;
            font-weight: 600;
          }
          
          .signature-image {
            border: 2px solid #e2e8f0;
            max-width: 200px;
            height: 80px;
            object-fit: contain;
            background: white;
          }
          
          .signature-field p {
            margin-top: 5px;
            font-size: 10px;
            color: #64748b;
            font-style: italic;
          }
          
          .terms {
            margin: 20px 0;
            padding: 12px;
            background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
            border-left: 4px solid #3b82f6;
            border-radius: 4px;
            font-size: 11px;
            line-height: 1.4;
          }
          
          .footer {
            margin-top: 20px;
            text-align: center;
            color: #64748b;
            font-size: 10px;
            border-top: 1px solid #e2e8f0;
            padding-top: 15px;
          }
          
          .print-button {
            position: fixed;
            top: 15px;
            right: 15px;
            padding: 8px 16px;
            background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
            color: white;
            border: none;
            border-radius: 8px;
            cursor: pointer;
            font-size: 12px;
            font-weight: 600;
            z-index: 1000;
            box-shadow: 0 2px 8px rgba(59, 130, 246, 0.3);
          }
          
          .print-button:hover {
            background: linear-gradient(135deg, #2563eb 0%, #1e40af 100%);
            transform: translateY(-1px);
          }
          
          /* Estilos para impressão - COMPACTO */
          @media print {
            body {
              margin: 0;
              padding: 10px;
              font-size: 10px;
            }
            
            .print-button {
              display: none;
            }
            
            .header h1 {
              font-size: 16px;
            }
            
            .header h2 {
              font-size: 12px;
            }
            
            .timestamp {
              font-size: 10px;
            }
            
            .items-table {
              font-size: 8px;
              margin: 5px 0;
            }
            
            .items-table th, .items-table td {
              padding: 3px 2px;
              line-height: 1.2;
            }
            
            .items-table th {
              font-size: 7px;
            }
            
            .signature-section {
              margin-top: 15px;
              gap: 20px;
            }
            
            .signature-image {
              max-width: 150px;
              height: 60px;
            }
            
            .signature-field h3 {
              font-size: 10px;
            }
            
            .signature-field p {
              font-size: 8px;
            }
            
            .terms {
              font-size: 9px;
              padding: 8px;
              margin: 15px 0;
            }
            
            .footer {
              font-size: 8px;
              margin-top: 15px;
            }
            
            /* Evitar quebra de página em elementos importantes */
            .signature-field {
              page-break-inside: avoid;
            }
            
            .terms {
              page-break-inside: avoid;
            }
          }
        </style>
      </head>
      <body>
        <div class="header">
          <h1>VEGA - Sistema de Estoque</h1>
          <h2>Comprovante de Entrega ${itemsToShow.length > 1 ? `- ${itemsToShow.length} peças` : `- ${itemData?.cod_sis || 'N/A'}`}</h2>
          <div class="timestamp">Data/Hora: ${new Date(timestamp).toLocaleString('pt-BR')}</div>
        </div>

        <div class="items-section">
          <h3>Informações dos Itens ${itemsToShow.length > 1 ? `(${itemsToShow.length} peças)` : ''}</h3>
          <table class="items-table">
            <thead>
              <tr>
                <th style="width: 15%;">COD.SIS</th>
                <th style="width: 20%;">Part Number</th>
                <th style="width: 35%;">Descrição</th>
                <th style="width: 15%;">Local Atual</th>
                <th style="width: 15%;">Status Atual</th>
              </tr>
            </thead>
            <tbody>
              ${itemsToShow.map(item => `
                <tr>
                  <td>${item.cod_sis || '-'}</td>
                  <td>${item.part_number || '-'}</td>
                  <td>${item.descricao || '-'}</td>
                  <td>${item.localizacao_fisica || '-'}</td>
                  <td>${item.status || '-'}</td>
                </tr>
              `).join('')}
            </tbody>
          </table>
        </div>

        <div class="signature-section">
          <div class="signature-field">
            <h3>Operador: ${operator.name}</h3>
            <img src="${operator.signature}" alt="Assinatura do Operador" class="signature-image" />
            <p>Assinatura do Entregador</p>
          </div>
          
          <div class="signature-field">
            <h3>Recebedor: ${receiver.name}</h3>
            <img src="${receiver.signature}" alt="Assinatura do Recebedor" class="signature-image" />
            <p>Assinatura do Recebedor</p>
          </div>
        </div>

        <div class="terms">
          <strong>Termo de Responsabilidade:</strong><br>
          Declaro para os devidos fins que recebi os itens listados acima em perfeitas condições 
          e concordo com a movimentação de estoque registrada. A responsabilidade pela guarda e 
          correto uso dos materiais passa a ser do recebedor a partir da data e hora desta assinatura.
        </div>

        <div class="footer">
          <p>Documento gerado automaticamente pelo Sistema VEGA em ${new Date().toLocaleString('pt-BR')}</p>
        </div>

        <button class="print-button" onclick="window.print()">🖨️ Imprimir/Salvar PDF</button>

        <script>
          // Auto-print quando a janela carregar
          window.onload = function() {
            setTimeout(function() {
              window.print();
            }, 1000);
          };
        </script>
      </body>
      </html>
    `;

    printWindow.document.write(htmlContent);
    printWindow.document.close();
  };

  return (
    <div className="signature-viewer-overlay">
      <div className="signature-viewer-modal">
        <div className="signature-viewer-header">
          <h2>📝 Assinaturas de Entrega</h2>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>

        <div className="signature-viewer-body">
          {/* Informações dos Itens */}
          {itemsToShow && itemsToShow.length > 0 && (
            <div className="item-info">
              <h3>Informações dos Itens {itemsToShow.length > 1 ? `(${itemsToShow.length} peças)` : ''}</h3>
              <table className="item-info-table">
                <thead>
                  <tr>
                    <th>COD.SIS</th>
                    <th>Part Number</th>
                    <th>Descrição</th>
                    <th>Local Atual</th>
                    <th>Status Atual</th>
                    <th>Data/Hora</th>
                  </tr>
                </thead>
                <tbody>
                  {itemsToShow.map((item, index) => (
                    <tr key={item.cod_sis || index}>
                      <td>{item.cod_sis || '-'}</td>
                      <td>{item.part_number || '-'}</td>
                      <td>{item.descricao || '-'}</td>
                      <td>{item.localizacao_fisica || '-'}</td>
                      <td>{item.status || '-'}</td>
                      <td>{new Date(timestamp).toLocaleString('pt-BR')}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {/* Assinaturas */}
          <div className="signatures-container">
            {/* Operador */}
            <div className="signature-display">
              <div className="signature-header">
                <h3>Operador</h3>
                <span className="signature-name">{operator.name}</span>
              </div>
              <div className="signature-image-container">
                <img 
                  src={operator.signature} 
                  alt="Assinatura do Operador" 
                  className="signature-image"
                />
                <div className="signature-label">Assinatura do Entregador</div>
              </div>
            </div>

            {/* Recebedor */}
            <div className="signature-display">
              <div className="signature-header">
                <h3>Recebedor</h3>
                <span className="signature-name">{receiver.name}</span>
              </div>
              <div className="signature-image-container">
                <img 
                  src={receiver.signature} 
                  alt="Assinatura do Recebedor" 
                  className="signature-image"
                />
                <div className="signature-label">Assinatura do Recebedor</div>
              </div>
            </div>
          </div>

          {/* Termo de Responsabilidade */}
          <div className="terms-display">
            <h3>Termo de Responsabilidade</h3>
            <p>
              Declaro para os devidos fins que recebi os itens listados acima em perfeitas condições 
              e concordo com a movimentação de estoque registrada. A responsabilidade pela guarda e 
              correto uso dos materiais passa a ser do recebedor a partir da data e hora desta assinatura.
            </p>
          </div>
        </div>

        <div className="signature-viewer-footer">
          <button className="btn btn-primary" onClick={downloadSignature}>
             Baixar/Imprimir
          </button>
          <button className="btn btn-outline" onClick={onClose}>
            Fechar
          </button>
        </div>
      </div>
    </div>
  );
};

export default SignatureViewer;
